import React, { Component } from 'react'

function About(){
    return (
        <React.Fragment>
        <h1> About </h1>
        <p> A simple ToDO (v1.0.0) app written in ReactJS </p>
        </React.Fragment>
        
        )
    
}

export default About
